export default __webpack_public_path__ + "4ab86f65c07e02c823cf2d4fa7bd00d9.png";